import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Table,
  Modal,
  message,
  InputNumber,
  Switch,
  Button,
  Radio,
} from "antd";
import NProgress from "nprogress";
import tipsEx from "../../../assets/images/tipsEx.png";
import "./index.scss";
import {
  fetchGetRules,
  fetchSetRules,
  fetchIntegraRules,
  fetchSetIntegraRules,
  fetchEvaluationRules,
  fetchEditEvaluationRules,
  fetchAISet,
  fetchSetAI,
} from "../../../api/rules";
import axios from "axios";
import { upload_token } from "../../../utils/token";
import Refresh from "../../../assets/images/refresh.png";
import Questionaire from "../../../assets/images/questionaire.png";
import AI_set from "../../../assets/images/AI_set.png";
const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/rules", name: "规则设置" },
];
class Rules extends React.Component {
  state = {
    active: 1,
    firstReceive: true,
    day: 0,
    x5Difference: 0,
    integralRuleList: [],
    integrals: [],
    memberGradeList: [],
    integralRuleList_copy: [],
    memberGradeList_copy: [],
    integrals_copy: [],
    token: upload_token(),
    loadingList: [],
    exVisible: false,
    editRules: false,
    editRules1: false,
    AI_checked: true,
    price: 1, //首次多少钱体验
    bonusRules: {
      days: 0,
      change_days: 0,
      amount: 0,
      change_amount: 0,
    },
    evaluationList: [
      {
        id: 1,
        label: "所有产品都必须进行真实的使用和严谨客观的测评。",
        loading: false,
        edit: false,
      },
    ],
    auditList: [
      {
        id: 1,
        label: "所有产品都必须进行真实的使用和严谨客观的测评。",
        loading: false,
        edit: false,
      },
    ],
  };
  setQuestion = (record) => {
    sessionStorage.setItem("questionTitle", "首次调查问卷");
    this.props.history.push("/page/ssry/question/-1");
  };
  AI_change = (e) => {
    fetchSetAI(e).then((res) => {
      if (res.success) {
        message.success("操作成功");
        this.setState({
          AI_checked: e,
        });
      }
    });
  };
  changeTabs = (e) => {
    this.setState({
      active: e,
    });
  };
  inputChange = (e) => {
    let value = e.target.value;
    switch (this.state.active) {
      case 2:
        if (value < 59) {
          this.setState({
            price: value,
            firstReceive: true,
          });
        }
        break;
      case 3:
        if (value < 9999) {
          this.setState({
            bonusRules: { ...this.state.bonusRules, change_amount: value },
          });
        }
        break;
      default:
        break;
    }
  };
  inputBlur = (e) => {
    let value = e.target.value;
    switch (this.state.active) {
      case 2:
        if (value && value.split(".")[1]) {
          if (value.split(".")[1].length > 2) {
            this.setState({
              price: (+value).toFixed(2),
            });
          } else {
            this.setState({
              price: +value,
            });
          }
        } else {
          this.setState({
            price: +value,
          });
        }
        break;
      case 3:
        if (value && value.split(".")[1]) {
          if (value.split(".")[1].length > 2) {
            this.setState({
              bonusRules: {
                ...this.state.bonusRules,
                change_amount: (+value).toFixed(2),
              },
            });
          } else {
            this.setState({
              bonusRules: { ...this.state.bonusRules, change_amount: +value },
            });
          }
        } else {
          this.setState({
            bonusRules: { ...this.state.bonusRules, change_amount: +value },
          });
        }
        break;
      default:
        break;
    }
  };
  getReceiveInfo = () => {
    fetchGetRules().then((res) => {
      if (res.success) {
        const { day, firstReceive, firstAmount, x5Difference } = res.data;
        this.setState({
          firstReceive,
          day,
          price: firstAmount / 100,
          x5Difference,
        });
      }
    });
  };
  getIntegraRules = () => {
    fetchIntegraRules().then((res) => {
      if (res.success) {
        let { integralRuleList, integrals, memberGradeList } = res.data;
        let arr = [];
        integrals.forEach((item) => {
          arr.push({
            integra: item,
            canEdit: false,
          });
        });
        integralRuleList.forEach((item) => {
          item.titleEdit = false;
          item.explainEdit = false;
          item.integralEdit = false;
        });
        let loadList = [];
        memberGradeList.forEach((item) => {
          item.rangeEdit = false;
          loadList.push(false);
        });
        this.setState({
          integralRuleList: [...integralRuleList],
          integrals: [...arr],
          memberGradeList: [...memberGradeList],
          integralRuleList_copy: JSON.parse(JSON.stringify(integralRuleList)),
          integrals_copy: JSON.parse(JSON.stringify(arr)),
          memberGradeList_copy: JSON.parse(JSON.stringify(memberGradeList)),
        });
      }
    });
  };
  getEvaluationRules = () => {
    fetchEvaluationRules().then((res) => {
      if (res.success) {
        let evaluationList = [];
        let auditList = [];
        res.data.evaluationStandardList.forEach((item) => {
          evaluationList.push({
            label: item,
            loading: false,
            edit: false,
          });
        });
        res.data.examineStandardList.forEach((item) => {
          auditList.push({
            label: item,
            loading: false,
            edit: false,
          });
        });
        this.setState({
          bonusRules: {
            days: res.data.retainDay,
            change_days: res.data.retainDay,
            amount: res.data.bonus ? res.data.bonus / 100 : 0,
            change_amount: res.data.bonus ? res.data.bonus / 100 : 0,
          },
          auditList,
          evaluationList,
        });
      }
    });
  };
  beforeSave = () => {
    let { evaluationList, bonusRules, auditList } = this.state;
    let evaluationStandardList = [];
    let examineStandardList = [];
    evaluationList.forEach((item) => {
      evaluationStandardList.push(item.label);
    });
    auditList.forEach((item) => {
      examineStandardList.push(item.label);
    });
    let info = {};
    info.retainDay = bonusRules.change_days;
    info.bonus = bonusRules.change_amount * 100;
    info.examineStandardList = examineStandardList;
    info.evaluationStandardList = evaluationStandardList;

    return info;
  };
  componentDidMount() {
    NProgress.start();
    this.getReceiveInfo();
    this.getIntegraRules();
    this.getEvaluationRules();
    this.getAISet();
    NProgress.done();
  }
  getAISet = () => {
    fetchAISet().then((res) => {
      if (res.success) {
        this.setState({
          AI_checked: res.data,
        });
      }
    });
  };
  priceChange = (e, index) => {
    let integrals = this.state.integrals;
    integrals[index].integra = e ? (+e).toFixed(0) : 0;
    this.setState({
      integrals,
    });
  };
  priceBlur = (index) => {
    setTimeout(() => {
      let list = this.state.integrals;
      if (list[index].integra == this.state.integrals_copy[index].integra) {
        list[index].canEdit = false;
        this.setState({
          integrals: list,
        });
        return;
      }
      let integrals = [];
      list.forEach((item) => {
        integrals.push(+item.integra);
      });
      const { memberGradeList, integralRuleList } = this.state;
      fetchSetIntegraRules({
        integrals,
        memberGradeList,
        integralRuleList,
      }).then((res) => {
        if (res.success) {
          message.success("设置成功");
          list[index].canEdit = false;
          this.setState({
            integrals: list,
            integrals_copy: JSON.parse(JSON.stringify(list)),
          });
        }
      });
    }, 0);
  };

  editSignIntegra = (index) => {
    let integrals = this.state.integrals;
    integrals[index].canEdit = true;
    this.setState({
      integrals,
    });
  };
  renderDate = () => {
    const { integrals } = this.state;
    return this.state.integrals.map((item, index) => {
      return (
        <div onClick={() => this.editSignIntegra(index)} key={index}>
          {item.canEdit ? (
            <InputNumber
              autoFocus
              min={index == 0 ? 1 : Number(integrals[index - 1].integra) + 1}
              max={
                index == integrals.length - 1
                  ? 9999
                  : Number(integrals[index + 1].integra) - 1
              }
              style={{ width: "80%" }}
              onBlur={() => this.priceBlur(index)}
              onChange={(e) => this.priceChange(e, index)}
              value={item.integra}
            ></InputNumber>
          ) : item.integra || item.integra === 0 ? (
            item.integra
          ) : (
            <span style={{ color: "rgba(0,0,0,.45)" }}>请输入积分</span>
          )}
        </div>
      );
    });
  };
  titleChange = (e, index) => {
    let integralRuleList = this.state.integralRuleList;
    integralRuleList[index].title = e.target.value;
    this.setState({
      integralRuleList,
    });
  };
  titleBlur = (index) => {
    setTimeout(() => {
      let list = this.state.integralRuleList;
      let list1 = this.state.integrals;
      if (list[index].title == this.state.integralRuleList_copy[index].title) {
        list[index].titleEdit = false;
        this.setState({
          integralRuleList: list,
        });
        return;
      }
      let integrals = [];
      list1.forEach((item) => {
        integrals.push(+item.integra);
      });

      const { memberGradeList } = this.state;
      fetchSetIntegraRules({
        integrals,
        memberGradeList,
        integralRuleList: list,
      }).then((res) => {
        if (res.success) {
          message.success("设置成功");
          list[index].titleEdit = false;
          this.setState({
            integralRuleList: list,
            integralRuleList_copy: JSON.parse(JSON.stringify(list)),
          });
        }
      });
    }, 0);
  };
  setTitle = (index) => {
    let integralRuleList = this.state.integralRuleList;
    integralRuleList[index].titleEdit = true;
    this.setState({
      integralRuleList,
    });
  };
  renderTitle = (text, record, index) => {
    return (
      <div onClick={() => this.setTitle(index)}>
        {record.titleEdit ? (
          <Input
            autoFocus
            maxLength={18}
            onBlur={() => this.titleBlur(index)}
            onChange={(e) => this.titleChange(e, index)}
            value={record.title}
            className="tableInput"
          ></Input>
        ) : record.title ? (
          record.title
        ) : (
          <span style={{ color: "rgba(0,0,0,.45)" }}>请输入标题</span>
        )}
      </div>
    );
  };
  explainChange = (e, index) => {
    let integralRuleList = this.state.integralRuleList;
    integralRuleList[index].explain = e.target.value;
    this.setState({
      integralRuleList,
    });
  };
  explainBlur = (index) => {
    setTimeout(() => {
      let list = this.state.integralRuleList;
      let list1 = this.state.integrals;
      if (
        list[index].explain == this.state.integralRuleList_copy[index].explain
      ) {
        list[index].explainEdit = false;
        this.setState({
          integralRuleList: list,
        });
        return;
      }
      let integrals = [];
      list1.forEach((item) => {
        integrals.push(+item.integra);
      });
      const { memberGradeList } = this.state;
      fetchSetIntegraRules({
        integrals,
        memberGradeList,
        integralRuleList: list,
      }).then((res) => {
        if (res.success) {
          message.success("设置成功");
          list[index].explainEdit = false;
          this.setState({
            integralRuleList: list,
            integralRuleList_copy: JSON.parse(JSON.stringify(list)),
          });
        }
      });
    }, 0);
  };
  setExplain = (index) => {
    let integralRuleList = this.state.integralRuleList;
    integralRuleList[index].explainEdit = true;
    this.setState({
      integralRuleList,
    });
  };
  renderExplain = (text, record, index) => {
    return (
      <div onClick={() => this.setExplain(index)}>
        {record.explainEdit ? (
          <Input
            autoFocus
            maxLength={22}
            onBlur={() => this.explainBlur(index)}
            onChange={(e) => this.explainChange(e, index)}
            value={record.explain}
            className="tableInput"
          ></Input>
        ) : record.explain ? (
          record.explain
        ) : (
          <span style={{ color: "rgba(0,0,0,.45)" }}>请输入文案</span>
        )}
      </div>
    );
  };
  rangeChange = (e, index) => {
    if (typeof e === "number") {
      let memberGradeList = this.state.memberGradeList;
      memberGradeList[index + 1].integral = e ? (1 + e).toFixed(0) : 0;
      this.setState({
        memberGradeList,
      });
    }
  };
  setRange = (index) => {
    let memberGradeList = this.state.memberGradeList;
    if (index < memberGradeList.length - 1) {
      memberGradeList[index].rangeEdit = true;
      this.setState({
        memberGradeList,
      });
    }
  };
  rangeBlur = (index) => {
    setTimeout(() => {
      let list = this.state.memberGradeList;
      let list1 = this.state.integrals;
      if (
        list[index + 1].integral ==
        this.state.memberGradeList_copy[index + 1].integral
      ) {
        list[index].rangeEdit = false;
        this.setState({
          memberGradeList: list,
        });
        return;
      }
      let integrals = [];
      list1.forEach((item) => {
        integrals.push(+item.integra);
      });
      const { integralRuleList } = this.state;
      fetchSetIntegraRules({
        integrals,
        memberGradeList: list,
        integralRuleList,
      }).then((res) => {
        if (res.success) {
          message.success("设置成功");
          list[index].rangeEdit = false;
          this.setState({
            memberGradeList: list,
            memberGradeList_copy: JSON.parse(JSON.stringify(list)),
          });
        }
      });
    }, 0);
  };
  renderRange = (text, record, index) => {
    const { memberGradeList } = this.state;
    return (
      <div onClick={() => this.setRange(index)}>
        {record.rangeEdit ? (
          <div className="rangeWrap">
            <div className="prefix">
              {record.integral}
              <span style={{ paddingLeft: 10 }}>
                <span>至</span>
              </span>
            </div>

            <InputNumber
              autoFocus
              min={1 + +record.integral}
              max={
                memberGradeList[index + 2]
                  ? memberGradeList[index + 2].integral -
                    memberGradeList.length +
                    (index + 1)
                  : 999999
              }
              onBlur={() => this.rangeBlur(index)}
              onChange={(e) => this.rangeChange(e, index)}
              value={memberGradeList[index + 1].integral - 1}
              className="tableInput"
            ></InputNumber>
          </div>
        ) : (
          <span>
            {record.integral}
            {index == memberGradeList.length - 1 ? (
              "+"
            ) : (
              <span style={{ paddingLeft: 10 }}>
                <span style={{ paddingRight: 10 }}>至</span>
                {memberGradeList[index + 1].integral - 1}
              </span>
            )}
          </span>
        )}
      </div>
    );
  };
  integralChange = (e, index) => {
    let integralRuleList = this.state.integralRuleList;
    integralRuleList[index].integral = e ? (+e).toFixed(0) : 0;
    this.setState({
      integralRuleList,
    });
  };
  integralBlur = (index) => {
    setTimeout(() => {
      let list = this.state.integralRuleList;
      let list1 = this.state.integrals;
      if (
        list[index].integral == this.state.integralRuleList_copy[index].integral
      ) {
        list[index].integralEdit = false;
        this.setState({
          integralRuleList: list,
        });
        return;
      }
      let integrals = [];
      list1.forEach((item) => {
        integrals.push(+item.integra);
      });
      const { memberGradeList } = this.state;
      fetchSetIntegraRules({
        integrals,
        memberGradeList,
        integralRuleList: list,
      }).then((res) => {
        if (res.success) {
          message.success("设置成功");
          list[index].integralEdit = false;
          this.setState({
            integralRuleList: list,
            integralRuleList_copy: JSON.parse(JSON.stringify(list)),
          });
        }
      });
    }, 0);
  };
  setIntegral = (index) => {
    let integralRuleList = this.state.integralRuleList;
    integralRuleList[index].integralEdit = true;
    this.setState({
      integralRuleList,
    });
  };
  renderIntegral = (text, record, index) => {
    return (
      <div onClick={() => this.setIntegral(index)}>
        {record.integralEdit ? (
          <InputNumber
            autoFocus
            min={0}
            max={9999}
            onBlur={() => this.integralBlur(index)}
            onChange={(e) => this.integralChange(e, index)}
            value={record.integral}
            className="tableInput"
          ></InputNumber>
        ) : record.integral || record.integral === 0 ? (
          record.integral
        ) : (
          <span style={{ color: "rgba(0,0,0,.45)" }}>请输入积分</span>
        )}
      </div>
    );
  };
  switchChange = (e, index) => {
    let integralRuleList = this.state.integralRuleList;
    if (e === false) {
      let num = 0;
      integralRuleList.forEach((item) => {
        if (item.enable) {
          num++;
        }
      });
      if (num === 1) {
        message.warning("至少保留一项");
        return false;
      }
    }
    integralRuleList[index].enable = e;
    const { memberGradeList } = this.state;
    let list1 = this.state.integrals;

    let integrals = [];
    list1.forEach((item) => {
      integrals.push(+item.integra);
    });
    fetchSetIntegraRules({
      integrals,
      memberGradeList,
      integralRuleList: integralRuleList,
    }).then((res) => {
      if (res.success) {
        message.success("设置成功");
        this.setState({
          integralRuleList,
        });
      }
    });
  };
  tagChange = (e, index) => {
    let file = e.target.files[0];
    if (file.size > 1024 * 1024) {
      message.error("上传图片不超过1M");
      return;
    }
    let loadingList = this.state.loadingList;
    loadingList[index] = true;
    this.setState({
      loadingList,
    });
    var formData = new FormData();
    formData.append("token", this.state.token);
    formData.append("file", file);
    formData.append("key", new Date().getTime() + "@image");
    axios({
      url: "https://upload.qiniup.com/",
      method: "post",
      data: formData,
    }).then((res) => {
      if (res.data.key) {
        let list1 = this.state.integrals;

        let integrals = [];
        list1.forEach((item) => {
          integrals.push(+item.integra);
        });
        let memberGradeList = this.state.memberGradeList;
        memberGradeList[index].tag =
          "http://qiniu-retail.ieou.com/" + res.data.key;
        fetchSetIntegraRules({
          integrals,
          memberGradeList,
          integralRuleList: this.state.integralRuleList,
        }).then((res) => {
          if (res.success) {
            message.success("设置成功");

            this.setState({
              memberGradeList,
            });
          }
          loadingList[index] = false;
          this.setState({
            loadingList,
          });
        });
      }
    });
    e.target.value = "";
  };
  X5_numChange = (e) => {
    var reg = /^([1-9]\d*|[0]{1,1})$/;
    if (reg.test(+e.target.value)) {
      this.setState({
        x5Difference: +e.target.value,
      });
    }
  };
  X5_numBlur = (e) => {
    if (+e.target.value <= 1) {
      this.setState({
        x5Difference: 1,
      });
    }
  };
  dayChange = (e) => {
    var reg = /^([1-9]\d*|[0]{1,1})$/;
    if (reg.test(+e.target.value)) {
      switch (this.state.active) {
        case 2:
          this.setState({
            day: +e.target.value,
          });
          break;
        case 3:
          this.setState({
            bonusRules: {
              ...this.state.bonusRules,
              change_days: +e.target.value,
            },
          });
          break;
        default:
          break;
      }
    }
  };
  dayBlur = (e) => {
    switch (this.state.active) {
      case 2:
        if (+e.target.value <= 1) {
          this.setState({
            day: 1,
          });
        }
        break;
      case 3:
        if (+e.target.value <= 1) {
          this.setState({
            bonusRules: { ...this.state.bonusRules, change_days: 1 },
          });
        }
        break;
      default:
        break;
    }
  };
  radioChange = (e) => {
    this.setState({
      firstReceive: e.target.value,
    });
  };
  saveBounsRules = () => {
    let info = this.beforeSave();
    fetchEditEvaluationRules(info).then((res) => {
      if (res.success) {
        message.success("操作成功");
        this.getEvaluationRules();
        this.setState({
          editRules1: false,
        });
      }
    });
  };
  saveReceiveRules = () => {
    const { day, firstReceive, price, x5Difference } = this.state;
    fetchSetRules({
      day,
      firstReceive,
      firstAmount: price * 100,
      x5Difference,
    }).then((res) => {
      if (res.success) {
        message.success("设置成功");
        this.getReceiveInfo();
        this.setState({
          editRules: false,
        });
      }
    });
  };
  deleteEvaluation = (index) => {
    let evaluationList = this.state.evaluationList;
    evaluationList[index].loading = true;
    this.setState({
      evaluationList,
    });
    let info = this.beforeSave();
    info.evaluationStandardList = info.evaluationStandardList.filter(
      (item, index1) => index != index1
    );
    fetchEditEvaluationRules(info).then((res) => {
      if (res.success) {
        message.success("操作成功");
        evaluationList[index].loading = false;
        evaluationList = evaluationList.filter(
          (item, index1) => index != index1
        );

        this.setState({
          evaluationList,
        });
      }
    });
  };
  editEvaluation = (index) => {
    let evaluationList = this.state.evaluationList;
    evaluationList[index].edit = true;
    this.setState({
      evaluationList,
    });
    setTimeout(() => {
      document.getElementById("evaluationInputRef" + index).focus();
    }, 0);
  };
  evaluationBlur = (index) => {
    let evaluationList = this.state.evaluationList;
    if (evaluationList[index].label.length == 0) {
      evaluationList = evaluationList.filter((item, index1) => index1 != index);
      this.setState({
        evaluationList,
      });
    } else {
      let info = this.beforeSave();
      fetchEditEvaluationRules(info).then((res) => {
        if (res.success) {
          message.success("操作成功");
          this.getEvaluationRules();
        }
      });
      // evaluationList[index].edit = false;
      // this.setState({
      //   evaluationList,
      // });
    }
  };
  evaluationChange = (e, index) => {
    let evaluationList = this.state.evaluationList;
    evaluationList[index].label = e.target.value;
    this.setState({
      evaluationList,
    });
  };
  addEvaluation = () => {
    this.setState(
      {
        evaluationList: [
          ...this.state.evaluationList,
          { label: "", edit: true, loading: false },
        ],
      },
      () => {
        document
          .getElementById(
            "evaluationInputRef" + (this.state.evaluationList.length - 1)
          )
          .focus();
      }
    );
  };
  deleteAudit = (index) => {
    let auditList = this.state.auditList;
    auditList[index].loading = true;
    this.setState({
      auditList,
    });
    let info = this.beforeSave();
    info.examineStandardList = info.examineStandardList.filter(
      (item, index1) => index != index1
    );
    fetchEditEvaluationRules(info).then((res) => {
      if (res.success) {
        message.success("操作成功");
        auditList[index].loading = false;
        auditList = auditList.filter((item, index1) => index != index1);

        this.setState({
          auditList,
        });
      }
    });
  };
  editAudit = (index) => {
    let auditList = this.state.auditList;
    auditList[index].edit = true;
    this.setState({
      auditList,
    });
    setTimeout(() => {
      document.getElementById("auditInputRef" + index).focus();
    }, 0);
  };
  auditBlur = (index) => {
    let auditList = this.state.auditList;
    if (auditList[index].label.length == 0) {
      auditList = auditList.filter((item, index1) => index1 != index);
      this.setState({
        auditList,
      });
    } else {
      let info = this.beforeSave();
      fetchEditEvaluationRules(info).then((res) => {
        if (res.success) {
          message.success("操作成功");
          this.getEvaluationRules();
        }
      });
    }
  };
  auditChange = (e, index) => {
    let auditList = this.state.auditList;
    auditList[index].label = e.target.value;
    this.setState({
      auditList,
    });
  };
  addAudit = () => {
    this.setState(
      {
        auditList: [
          ...this.state.auditList,
          { label: "", edit: true, loading: false },
        ],
      },
      () => {
        document
          .getElementById("auditInputRef" + (this.state.auditList.length - 1))
          .focus();
      }
    );
  };
  render() {
    const {
      active,
      firstReceive,
      day,
      x5Difference,
      integralRuleList,
      integrals,
      memberGradeList,
      loadingList,
      exVisible,
      editRules,
      editRules1,
      price,
      bonusRules,
      evaluationList,
      auditList,
      AI_checked,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="rules_container">
          <div className="tabs">
            <div
              onClick={() => this.changeTabs(1)}
              className={active == 1 ? "item active" : "item"}
            >
              积分规则
            </div>
            <div
              onClick={() => this.changeTabs(2)}
              className={active == 2 ? "item active" : "item"}
            >
              领取规则
            </div>
            <div
              onClick={() => this.changeTabs(3)}
              className={active == 3 ? "item active" : "item"}
            >
              测评规则
            </div>
            <div
              onClick={() => this.changeTabs(4)}
              className={active == 4 ? "item active" : "item"}
            >
              AI规则
            </div>
            <div
              style={{ left: (active - 1) * 104 }}
              className="bottomLine"
            ></div>
          </div>
          <div className={active == 4 ? "" : "none"}>
            <div className="card clearfix">
              <div className="fl left">
                <img className="icon" src={Questionaire}></img>首次问卷设置
              </div>
              <Button className="fr" onClick={this.setQuestion} type="primary">
                设置问卷
              </Button>
            </div>
            <div className="card clearfix">
              <div className="fl left">
                <img className="icon" src={AI_set}></img>AI测肤功能：
                <Switch checked={AI_checked} onChange={this.AI_change} />
              </div>
              <div style={{ lineHeight: "32px" }} className="fr">
                （<span style={{ color: "#D0021B" }}>*</span>
                默认为开启状态，开启状态下新用户第一次试用必须进行AI测肤）
              </div>
            </div>
          </div>
          <div className={active == 3 ? "" : "none"}>
            <div className="card">
              <div className="title">
                <span style={{ fontSize: 16 }}>奖金发放规则</span>
                <Button
                  onClick={() =>
                    this.setState({
                      editRules1: true,
                    })
                  }
                  className={!editRules1 ? "fr" : "none"}
                  type="primary"
                >
                  修改规则
                </Button>
                <div className={editRules1 ? "fr" : "none"}>
                  <Button
                    className="marginR"
                    onClick={() => {
                      let obj = this.state.bonusRules;
                      obj.change_amount = obj.amount;
                      obj.change_days = obj.days;
                      this.setState({
                        editRules1: false,
                        bonusRules: obj,
                      });
                    }}
                  >
                    取 消
                  </Button>
                  <Button type="primary" onClick={this.saveBounsRules}>
                    保 存
                  </Button>
                </div>
              </div>
              <div>
                <div className="Row">
                  <div className="label">规则一</div>
                  <div className="value">
                    测评内容发布后，需保留
                    {editRules1 ? (
                      <Input
                        suffix="天"
                        className="priceInput"
                        value={bonusRules.change_days}
                        onBlur={this.dayBlur}
                        onChange={this.dayChange}
                      />
                    ) : (
                      <span>{bonusRules.days}天</span>
                    )}
                  </div>
                </div>
                <div className="Row">
                  <div className="label">规则二</div>
                  <div className="value">
                    发放奖金金额
                    {editRules1 ? (
                      <Input
                        value={bonusRules.change_amount}
                        onChange={this.inputChange}
                        onBlur={this.inputBlur}
                        className="priceInput"
                        suffix="元"
                      />
                    ) : (
                      <span>{bonusRules.amount}元 </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* zhebianbianji */}
            <div className="card">
              <div className="title">
                <span style={{ fontSize: 16 }}>
                  测评规范说明（说明仅限添加5条）
                </span>
              </div>
              <div className="table">
                <div className="item head">
                  <div className="sonItem fl">ID</div>
                  <div style={{ paddingLeft: 15 }} className="sonItem fr last">
                    操作
                  </div>
                  <div className="sonItem center">测评规范说明</div>
                </div>
                {evaluationList.map((item, index) => {
                  return (
                    <div key={item + index} className="item">
                      <div className="sonItem fl">{index + 1}</div>
                      <div className="sonItem fr last">
                        <Button
                          loading={item.loading}
                          onClick={() => this.deleteEvaluation(index)}
                          type="link"
                        >
                          删除
                        </Button>
                      </div>
                      <div className="sonItem center">
                        <span className={item.edit ? "inputWrap" : "none"}>
                          <span className="count">{item.label.length}/40</span>
                          <Input
                            id={"evaluationInputRef" + index}
                            onBlur={() => this.evaluationBlur(index)}
                            onChange={(e) => this.evaluationChange(e, index)}
                            maxLength={40}
                            value={item.label}
                            placeholder="请填入说明"
                          />
                        </span>

                        <span
                          style={{
                            height: 54,
                            display: "inline-block",
                            width: "100%",
                          }}
                          className={!item.edit ? "" : "none"}
                          onClick={() => this.editEvaluation(index)}
                        >
                          {item.label}
                        </span>
                      </div>
                    </div>
                  );
                })}
                <div
                  onClick={this.addEvaluation}
                  style={{ color: "rgba(0,0,0,.45)", cursor: "pointer" }}
                  className={evaluationList.length >= 5 ? "none" : "tips"}
                >
                  +添加规则说明
                </div>
                <div className={evaluationList.length < 5 ? "none" : "tips"}>
                  规则已达上限，不能添加
                </div>
              </div>
            </div>

            <div className="card">
              <div className="title">
                <span style={{ fontSize: 16 }}>
                  审核规范说明（说明仅限添加5条）
                </span>
              </div>
              <div className="table">
                <div className="item head">
                  <div className="sonItem fl">ID</div>
                  <div style={{ paddingLeft: 15 }} className="sonItem fr last">
                    操作
                  </div>
                  <div className="sonItem center">审核规范说明</div>
                </div>
                {auditList.map((item, index) => {
                  return (
                    <div key={item + index} className="item">
                      <div className="sonItem fl">{index + 1}</div>
                      <div className="sonItem fr last">
                        <Button
                          loading={item.loading}
                          onClick={() => this.deleteAudit(index)}
                          type="link"
                        >
                          删除
                        </Button>
                      </div>
                      <div className="sonItem center">
                        <span className={item.edit ? "inputWrap" : "none"}>
                          <span className="count">{item.label.length}/40</span>
                          <Input
                            id={"auditInputRef" + index}
                            onBlur={() => this.auditBlur(index)}
                            onChange={(e) => this.auditChange(e, index)}
                            maxLength={40}
                            value={item.label}
                            placeholder="请填入说明"
                          />
                        </span>

                        <span
                          style={{
                            height: 54,
                            display: "inline-block",
                            width: "100%",
                          }}
                          className={!item.edit ? "" : "none"}
                          onClick={() => this.editAudit(index)}
                        >
                          {item.label}
                        </span>
                      </div>
                    </div>
                  );
                })}
                <div
                  onClick={this.addAudit}
                  style={{ color: "rgba(0,0,0,.45)", cursor: "pointer" }}
                  className={auditList.length >= 5 ? "none" : "tips"}
                >
                  +添加规则说明
                </div>
                <div className={auditList.length < 5 ? "none" : "tips"}>
                  规则已达上限，不能添加
                </div>
              </div>
            </div>
          </div>
          <div className={active == 2 ? "" : "none"}>
            <div className="card">
              <div className="title">
                <span style={{ fontSize: 16 }}>商品领取设置</span>
                <Button
                  onClick={() =>
                    this.setState({
                      editRules: true,
                    })
                  }
                  className={!editRules ? "fr" : "none"}
                  type="primary"
                >
                  修改规则
                </Button>
                <div className={editRules ? "fr" : "none"}>
                  <Button
                    className="marginR"
                    onClick={() => {
                      this.getReceiveInfo();
                      this.setState({
                        editRules: false,
                      });
                    }}
                  >
                    取 消
                  </Button>
                  <Button type="primary" onClick={this.saveReceiveRules}>
                    保 存
                  </Button>
                </div>
              </div>

              <div>
                <div className="Row">
                  <div className="label">规则一</div>
                  <div className="value">
                    同一种SKU
                    {editRules ? (
                      <Input
                        suffix="天"
                        className="priceInput"
                        value={day}
                        onBlur={this.dayBlur}
                        onChange={this.dayChange}
                      />
                    ) : (
                      <span>{day}天</span>
                    )}
                    内不能重复领取
                  </div>
                </div>
                <div className="Row">
                  <div className="label">规则二</div>
                  <div className={editRules ? "none" : "value"}>
                    针对X5设备，不同SKU商品的领取数量差不能高于 {x5Difference}{" "}
                    个
                  </div>
                  <div className={!editRules ? "none" : "value"}>
                    针对X5设备，不同SKU商品的领取数量差不能高于
                    <Input
                      suffix="个"
                      className="priceInput"
                      value={x5Difference}
                      onBlur={this.X5_numBlur}
                      onChange={this.X5_numChange}
                    />
                  </div>
                  {/* <div className={editRules ? "none" : "value"}>
                    {firstReceive ? `首次${price}元体验` : "首次领取不免费"}
                  </div>
                  <div className={!editRules ? "none" : "value"}>
                    <Radio.Group
                      onChange={this.radioChange}
                      value={firstReceive}
                    >
                      <Radio value={true}>
                        首次
                        <Input
                          value={price}
                          onChange={this.inputChange}
                          onBlur={this.inputBlur}
                          className="priceInput"
                          suffix="元"
                        />
                        体验
                      </Radio>
                      <Radio value={false}>首次领取不免费</Radio>
                    </Radio.Group>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className={active == 1 ? "" : "none"}>
            <div className="card">
              <div className="title">签到积分设置</div>
              <div className="tips">
                <span style={{ color: "#d0021b" }}>*</span>签到周期为 7 天
              </div>
              <div className="table">
                <div className="th">
                  <div>第一天</div>
                  <div>第二天</div>
                  <div>第三天</div>
                  <div>第四天</div>
                  <div>第五天</div>
                  <div>第六天</div>
                  <div>第七天</div>
                </div>
                <div className="td">{this.renderDate()}</div>
              </div>
            </div>
            <div className="card">
              <div className="title">
                积分获取方式设置
                <a
                  onClick={() =>
                    this.setState({
                      exVisible: true,
                    })
                  }
                  style={{ fontWeight: 400 }}
                  className="fr"
                >
                  小程序示意
                </a>
              </div>
              <Table
                rowKey="mode"
                pagination={false}
                dataSource={integralRuleList}
              >
                <Column
                  width="15%"
                  render={(value) => (
                    <span style={{ fontWeight: 700, color: "#000" }}>
                      {value}
                    </span>
                  )}
                  title="积分获取方式"
                  dataIndex="mode"
                  key="mode"
                />
                <Column
                  width="32.5%"
                  align="center"
                  title="标题"
                  render={this.renderTitle}
                />
                <Column
                  width="32.5%"
                  align="center"
                  title="辅助文案"
                  render={this.renderExplain}
                />
                <Column
                  width="10%"
                  align="center"
                  title="获得积分"
                  render={this.renderIntegral}
                />
                <Column
                  align="center"
                  width="10%"
                  title="操作"
                  render={(text, record, index) => {
                    return (
                      <Switch
                        checked={record.enable}
                        onChange={(e) => this.switchChange(e, index)}
                      />
                    );
                  }}
                />
              </Table>
            </div>
            <div className="card">
              <div className="title">积分等级设置</div>
              <Table
                rowKey="name"
                pagination={false}
                dataSource={memberGradeList}
              >
                <Column
                  width="15%"
                  render={(value) => (
                    <span style={{ fontWeight: 700, color: "#000" }}>
                      {value}
                    </span>
                  )}
                  title="积分等级"
                  dataIndex="name"
                  key="name"
                />
                <Column
                  width="32.5%"
                  align="center"
                  title="积分范围"
                  render={this.renderRange}
                />
                <Column
                  width="32.5%"
                  align="center"
                  title="积分勋章"
                  render={(record) => {
                    return <img className="tag" src={record.tag}></img>;
                  }}
                />

                <Column
                  align="center"
                  width="10%"
                  title="操作"
                  render={(text, record, index) => {
                    return (
                      // <Button
                      //   disabled={loadingList[index]}
                      //   loading={loadingList[index]}
                      //   className="uploadTag"
                      // >
                      //   <input
                      //     type="file"
                      //     accept="image/*"
                      //     onChange={($event) => this.tagChange($event, index)}
                      //   ></input>
                      //   {loadingList[index] ? "正在上传" : "上传图片"}
                      // </Button>
                      <div className="uploadTag">
                        {loadingList[index] ? (
                          <img className="loadingIcon" src={Refresh}></img>
                        ) : null}
                        <input
                          disabled={loadingList[index]}
                          type="file"
                          accept="image/*"
                          onChange={($event) => this.tagChange($event, index)}
                        ></input>
                        {loadingList[index] ? (
                          <span className="loading">正在上传</span>
                        ) : (
                          "上传图片"
                        )}
                      </div>
                    );
                  }}
                />
              </Table>
            </div>
          </div>
        </div>
        <Modal
          title="小程序示意图"
          visible={exVisible}
          width="700px"
          onCancel={() => {
            this.setState({
              exVisible: false,
            });
          }}
          footer={null}
        >
          <img className="tipsEx" src={tipsEx}></img>
        </Modal>
      </div>
    );
  }
}

export default Rules;
